import { ParametersDetailDTO } from "../parameters/ParametersDTO";
import { NovedadSolicitudDTO } from "./NovedadSolicitudDTO";
import { SolicitudPasajeroDTO } from "./SolicitudPasajeroDTO";
import { SolicitudRecorridosDTO } from "./SolicitudRecorridosDTO";


export class Solicitud {
  id: any;
  dtFechaSolicitud: any;
  dtFechaPrestacionServicio: any;
  tipoTransporteId: any;
  tipoTransporte!: ParametersDetailDTO;
  iCantidadPasajeros: any;
  tipoServicioId: any;
  tipoServicio!: ParametersDetailDTO;
  txJustificacion: any;
  estadoId: any;
  bSolicitudAjustada: any;
  dependenciaId: any;
  dependencia!: ParametersDetailDTO;
  directorJefeDependenciaId: any;
  directorJefeDependencia!: ParametersDetailDTO;
  maquinaEstado: any;
  maquinaEstadoId: any;
  motivoCancelacionId: any;
  txtObservacion: any;
  txtObservacionRechazo: any;
  txtObservacionDatosValidacion: any;
  usuarioId: any;
  referente: any;
  vehiculoId: any;
  vehiculo: any;
  vehiculoSubContratadoId: any;
  vehiculoSubContratado: any;
  conductorId: any;
  conductor: any;
  TxArchivoAdjunto: any;
  recorridos: SolicitudRecorridosDTO[] = [];
  pasajeros: SolicitudPasajeroDTO[] = [];
  novedades: NovedadSolicitudDTO[] = [];
  relacionadas: SolicitudesRelacionadas[] = [];
}

export interface SolicitudesRelacionadas {
  id: number;
  solicitudPrincipalId: number;
  solicitudSecundariaId: number;
  solicitudClonadaId: number;
  dtFechaRegistro: Date;
}